import * as React from 'react';
import Image from 'next/image';

type IAboutProps = object;

const AboutThree: React.FunctionComponent<IAboutProps> = () => {
  return (
    <section id='about' className='pb-20 lg:pb-25 xl:pb-30 overflow-hidden pt-30'>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 xl:px-0'>
        {/* Header added here */}
        <h1 className='text-black text-4xl xl:text-hero font-bold mb-10 pl-5'>AI Enrichment </h1>
        <h4 className='text-black text-lg font-medium mb-10 pl-5'>
          Enriched prospect information delivered to your CRM
        </h4>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left hidden md:block md:w-1/2'>
            <Image src='/images/products/other/leadsList.png' alt='About' width={600} height={400} />
          </div>
          <div className='animate_right md:w-1/2'>
            <h4 className='text-black  font-medium uppercase'>Auto enrich prospect data</h4>
            <h2 className='relative font-bold text-black  text-3xl xl:text-hero mb-6'>
              Know who and what your prospects{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg before:-z-1'>
                are seeking
              </span>
            </h2>
            <p>Single email for :</p>
            <ul className='list-disc list-inside'>
              <li>Fully enriched B2B data including LinkedIn</li>
              <li>Professional work experience </li>
              <li>Buyer intent </li>
              <li>Occupation/Interests</li>
            </ul>
          </div>
        </div>
      </div>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 2xl:px-0 pt-30'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left md:w-1/2'>
            <h4 className='text-black font-medium uppercase'>Auto summaries and lead scoring</h4>
            <h2 className='relative font-bold text-black text-3xl xl:text-hero mb-6'>
              Identify the top propsects with
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg2 before:-z-1'>
                lead scoring
              </span>
            </h2>
            <p>Speed up your follow ups :</p>
            <ul className='list-disc list-inside'>
              <li>Receive a summary of what the buyer is looking for</li>
              <li>Lead scoring based on interaction</li>
              <li>Customize follow up based on location/company</li>
            </ul>
          </div>
          <div className='animate_right hidden md:block md:w-1/2'>
            <Image src='/images/products/other/leadsView.png' alt='About' width={600} height={400} />
            <Image src='/images/about/about-dark-02.svg' alt='About' width={600} height={400} className='hidden' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutThree;
